import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { insights as staticInsights } from '../data';
import AboutHero from '../components/AboutHero/AboutHero';
import InsightArticle from '../components/InsightArticle/InsightArticle';
import RelatedPosts from '../components/RelatedPosts/RelatedPosts';
import Footer from '../components/Footer/Footer';
import "../styles/SpecificInsight.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchInsightById, fetchInsights } from '../features/insight/insightActions';
import { Helmet } from 'react-helmet';
const SpecificInsight = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { insight, insights, loading, error } = useSelector((state) => state.insights);
  const staticInsight = staticInsights.find((b) => b.slug_url === slug);
  useEffect(() => {
    if (!staticInsight && slug) {
      dispatch(fetchInsightById(slug));
    }
  }, [dispatch, slug, staticInsight]);

  useEffect(() => {
    if (!insights || insights.length === 0) {
      dispatch(fetchInsights());
    }
  }, [dispatch, insights]);
  const insightData = staticInsight || insight
  // const otherBlogs = staticInsights.filter((b) => b.slug_url !== slug).slice(0, 3);

  if (loading && !staticInsight) return <div>imran</div>;

  if (error && !staticInsight) {
    return (
      <div style={{ textAlign: "center", padding: "4rem 0", color: "#999" }}>
        <h2>Error: {error}</h2>
      </div>
    );
  }

  if (!insightData) {
    return (
      <div style={{ textAlign: "center", padding: "4rem 0", color: "#999" }}>
        <h2>Insight not found</h2>
      </div>
    );
  }

  const combinedMap = new Map();

  [...staticInsights, ...(insights || [])].forEach((b) => {
    // Key priority: slug_url > _id
    const key = b.slug_url || b._id;
    combinedMap.set(key, b);
  });

  const allInsights = Array.from(combinedMap.values());
  // ✅ Filter out the current blog
  const otherInsights = allInsights.filter(
    (b) => {
      return (b.slug_url !== insightData.slug_url);
    }
  );
  // ✅ Find related by category
  const relatedByCategory = otherInsights.filter(
    (b) => b.category?.toLowerCase() === insightData.category?.toLowerCase()
  );
  // ✅ Fallback: 3 random posts
  const relatedPosts =
    relatedByCategory.length > 2
      ? relatedByCategory
      : otherInsights.sort(() => 0.5 - Math.random()).slice(0, 3);


  return (
    <div>
      <Helmet>
        {insightData?.metaTitle && <title>{insightData.metaTitle}</title>}
        {insightData?.metaDescription && <meta name='description' content={insightData.metaDescription} />}
      </Helmet>
      <AboutHero
        page="insight"
        title={insightData.title}
        subtitle={insightData.metaDescription || insightData.brief_paragraph}
      />
      <div className='bg_gradient'>
        <InsightArticle insightData={insightData} />
        <RelatedPosts page="blog" relatedPosts={relatedPosts} />
      </div>
      <Footer />
    </div>
  )
}

export default SpecificInsight